import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../../styles/TaskDetails.module.css';

interface TaskStatisticsProps {
  taskId: string;
  groupId?: string | null;
  assigneesCount: number;
  inProgressCount: number;
  completedCount: number;
  totalPoints: number;
}

const TaskStatistics: React.FC<TaskStatisticsProps> = ({
  taskId,
  groupId,
  assigneesCount,
  inProgressCount,
  completedCount,
  totalPoints
}) => {
  const navigate = useNavigate();

  const handleNavigation = (tab: string) => {
    if (groupId) {
      navigate(`/group-management/groups/${groupId}/tasks/${taskId}/${tab}`);
    } else {
      navigate(`/task-management/${taskId}/${tab}`);
    }
  };

  return (
    <div className={styles.templateStatisticsSection}>
      <div className={styles.statisticsGrid}>
        <div className={styles.statisticCard}>
          <div className={styles.statisticValue}>{assigneesCount}</div>
          <div className={styles.statisticLabel}>TOTAL ASSIGNEES</div>
        </div>

        <div className={styles.statisticCard}>
          <div className={styles.statisticValue}>{inProgressCount}</div>
          <div className={styles.statisticLabel}>IN PROGRESS</div>
        </div>

        <div className={styles.statisticCard}>
          <div className={styles.statisticValue}>{completedCount}</div>
          <div className={styles.statisticLabel}>COMPLETED</div>
        </div>

        <div className={styles.statisticCard}>
          <div className={styles.statisticValue}>{totalPoints}</div>
          <div className={styles.statisticLabel}>TOTAL POINTS</div>
        </div>
      </div>

    </div>
  );
};

export default TaskStatistics;

